import React from 'react';
import { Modal, View, StyleSheet, Platform, TouchableOpacity, Dimensions, ScrollView, Text, SafeAreaView } from 'react-native';
import Colors from '../../constants/Colors';
import CS from '../../constants/Styles';
import { Button, ULItem, BackgroundGradient, ToggleButtons } from '../../components';
import * as rtApi from '../../components/Api';
import SignatureScreen from 'react-native-signature-canvas';
import { AntDesign, Feather, FontAwesome5 } from '@expo/vector-icons';
import { TextInput } from 'react-native-paper';
import * as FileSystem from 'expo-file-system';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { Portal } from 'react-native-paper';
import UserState from '../../src/contexts/UserState';
import * as WebBrowser from 'expo-web-browser';
import * as Linking from 'expo-linking';

export default function InvitePreviewModal({ ...props }) {
  const [user, setUser] = React.useContext(UserState);
  const insets = useSafeAreaInsets();
  const [previewType, setPreviewType] = React.useState(true);
  const [topBlurb, setTopBlurb] = React.useState('');

  const customerContractorText = props.role === 'homeowner' ? 'contractor' : 'customer';
  const customerContractorText2 = props.role === 'homeowner' ? 'Contractor' : 'Customer';

  const windowWidth = Dimensions.get('window').width;

  React.useEffect(() => {
    buildTopBlurb()
  }, [props.email, props.sms])

  const buildTopBlurb = () => {
    console.log('buildTopBlurb');
    if(props.email && props.sms){
      console.log('email && sms');
      // setTopBlurb(`This is a preview of the invitation messaging that will be sent to your ${customerContractorText}. If you see any incorrect information, please go back and change it. Check both the email and text/SMS messages.`);
      setTopBlurb(`This is a preview of the invitation that will be sent to your ${customerContractorText}. Review both the email and text/SMS messages. If you see any incorrect information, please go back and correct it.`);
    }else if(props.email){
      console.log('email');
      setTopBlurb(`This is a preview of the invitation that will be sent to your ${customerContractorText}. Review the email message. If you see any incorrect information, please go back and correct it.`);
    } else if (props.sms) {
      console.log('sms');
      setTopBlurb(`This is a preview of the invitation that will be sent to your ${customerContractorText}. Review the text/SMS message. If you see any incorrect information, please go back and correct it.`);
    }
  }

  const contactBlurb = () => {
   return <Text style={[CS.smallText, CS.lightBlueText, CS.italicText, styles.paragraph]}>Learn more about Renovation Trust at <Link url='https://www.renovationtrust.com/' />. You can also reach out to our customer service team.</Text>
  }

  const personalMessage = () => {
    if(props.personalMessage){
      return <Text style={[CS.smallText, CS.lightBlueText, CS.italicText, styles.paragraph]}>{props.personalMessage}</Text>
    }
    return null;
  }

  const emailContent = {
    homeowner: {
      Project: [
        <Text style={[CS.smallText, CS.lightBlueText, styles.paragraph]}>{props.toName}, {user.full_name} of {props.address} wants to move ahead with their {props.projectName} project you quoted for them.</Text>,
        <Text style={[CS.smallText, CS.lightBlueText, styles.paragraph]}>Your customer wants to use Renovation Trust to protect the money for both you and them.</Text>,
        <Text style={[CS.smallText, CS.lightBlueText, styles.paragraph]}>This is an invitation to join and accept the project. Once you accept the project they’ll deposit the entire cost of the project with Renovation Trust and it will be released to you as the project is completed.</Text>,
        <Text style={[CS.smallText, CS.lightBlueText, CS.boldText]}>Your Customer's Information</Text>,
        <Text style={[CS.smallText, CS.lightBlueText]}>{user.full_name}</Text>,
        <Text style={[CS.smallText, CS.lightBlueText]}>{user.phone_number_mobile || user.phone_number_home}</Text>,
        <Text style={[CS.smallText, CS.lightBlueText, styles.paragraph]}>{user.email_address}</Text>,
        <Text style={[CS.smallText, CS.lightBlueText, styles.paragraph]}>Reach out to your customer if you need clarification or to discuss any matters.</Text>,
        <Text style={[CS.smallText, CS.lightBlueText, styles.paragraph]}>If you don’t have an account already, you will have an opportunity to create one before viewing the project details. Otherwise you’ll be prompted to login.</Text>,
      ],
      Create: [
        <Text style={[CS.smallText, CS.lightBlueText, styles.paragraph]}>{props.toName}, {user.full_name} of {props.address} wants to move ahead with the {props.projectName} project you quoted for them.</Text>,
        <Text style={[CS.smallText, CS.lightBlueText, styles.paragraph]}>Your customer wants to use Renovation Trust to protect the money for both you and them.</Text>,
        <Text style={[CS.smallText, CS.lightBlueText, styles.paragraph]}>As their contractor, they would like you to set up the project in Renovation Trust and then invite them to join and accept the project terms. Once they have joined and accepted the project, they'll deposit the full cost of the project with Renovation Trust. As soon as the funds have cleared, we will inform you so you can begin the work and request payments at your agreed to milestones and/or upon completion.</Text>,
        <Text style={[CS.smallText, CS.lightBlueText, CS.boldText]}>Your Customer's Information</Text>,
        <Text style={[CS.smallText, CS.lightBlueText]}>{user.full_name}</Text>,
        <Text style={[CS.smallText, CS.lightBlueText]}>{user.phone_number_mobile || user.phone_number_home}</Text>,
        <Text style={[CS.smallText, CS.lightBlueText, styles.paragraph]}>{user.email_address}</Text>,
        <Text style={[CS.smallText, CS.lightBlueText, styles.paragraph]}>Reach out to your customer if you need clarification or to discuss any matters.</Text>
      ],
      Quote: [
        <Text style={[CS.smallText, CS.lightBlueText, styles.paragraph]}>{props.toName}, {user.full_name} of {props.address} wants you to quote their {props.projectName} project.</Text>,
      ]
    },
    contractor: {
      Project: [
        <Text style={[CS.smallText, CS.lightBlueText, styles.paragraph]}>Your contractor {props.toName}, from {user.company_name}, has created your {props.projectName} project in Renovation Trust providing protection for both of you.</Text>,
        <Text style={[CS.smallText, CS.lightBlueText, styles.paragraph]}>You need to review the details and accept the project before things can proceed.</Text>,
        <Text style={[CS.smallText, CS.lightBlueText, CS.boldText]}>Your Contractor’s Information</Text>,
        <Text style={[CS.smallText, CS.lightBlueText]}>{user.company_name}</Text>,
        <Text style={[CS.smallText, CS.lightBlueText]}>{user.full_name}</Text>,
        <Text style={[CS.smallText, CS.lightBlueText]}>{user.company_phone_number}</Text>,
        <Text style={[CS.smallText, CS.lightBlueText]}>{user.company_email}</Text>,
        <Text style={[CS.smallText, CS.lightBlueText, styles.paragraph, { marginTop: 10 }]}>If you don’t have an account already, you will have an opportunity to create one before viewing the project details. Otherwise you’ll be prompted to login.</Text>,
      ],
      // Create: [
      //   <Text style={[CS.smallText, CS.lightBlueText, styles.paragraph]}>{props.toName}, {user.full_name} of {props.address} wants to move ahead with the {props.projectName} project you quoted for them.</Text>,
      //   <Text style={[CS.smallText, CS.lightBlueText, styles.paragraph]}>Your {customerContractorText} wants to use Renovation Trust to protect the money for both you and them.</Text>,
      //   <Text style={[CS.smallText, CS.lightBlueText, styles.paragraph]}>As their {customerContractorText}, they would like you to set up the project in Renovation Trust and then invite them to join and accept the project terms. Once they have joined and accepted the project, they'll deposit the full cost of the project with Renovation Trust. As soon as the funds have cleared, we will inform you so you can begin the work and request payments at your agreed to milestones and/or upon completion.</Text>,
      //   <Text style={[CS.smallText, CS.lightBlueText, CS.boldText]}>Your {customerContractorText2}'s Information</Text>,
      //   <Text style={[CS.smallText, CS.lightBlueText]}>{user.full_name}</Text>,
      //   <Text style={[CS.smallText, CS.lightBlueText]}>{user.phone_number_mobile || user.phone_number_home}</Text>,
      //   <Text style={[CS.smallText, CS.lightBlueText, styles.paragraph]}>{user.email_address}</Text>,
      //   <Text style={[CS.smallText, CS.lightBlueText, styles.paragraph]}>Reach out to your {customerContractorText} if you need clarification or to discuss any matters.</Text>
      // ],
      Quote: [
        <Text style={[CS.smallText, CS.lightBlueText, styles.paragraph]}>{props.toName}, {user.full_name} of {props.address} wants you to quote their {props.projectName} project.</Text>,
      ]
    },
  }

  const smsContent = {
    homeowner: {
      Project: [
        <Text style={[CS.smallText, CS.lightBlueText, styles.paragraph]}>{user.full_name} of {props.address}, wants to move forward with their {props.projectName} project using Renovation Trust to protect themselves and you.</Text>,
        <Text style={[CS.smallText, CS.lightBlueText, styles.paragraph]}>This is an invitation to join and accept the project. Once you accept the project they’ll deposit the entire cost of the project with Renovation Trust and it will be released to you as the project is completed.</Text>,
        <Text style={[CS.smallText, CS.lightBlueText]}>Your Customer's Information:</Text>,
        <Text style={[CS.smallText, CS.lightBlueText]}>{user.full_name}</Text>,
        <Text style={[CS.smallText, CS.lightBlueText]}>{user.phone_number_mobile || user.phone_number_home}</Text>,
        <Text style={[CS.smallText, CS.lightBlueText, styles.paragraph]}>{user.email_address}</Text>,
        <Text style={[CS.smallText, CS.lightBlueText, styles.paragraph]}>Reach out to your customer if you need clarification or to discuss any matters.</Text>,
        <Text style={[CS.smallText, CS.lightBlueText, styles.paragraph]}>If you don’t have an account already, you will have an opportunity to create one before viewing the project details. Otherwise you’ll be prompted to login.</Text>,
      ],
      Create: [
        <Text style={[CS.smallText, CS.lightBlueText, styles.paragraph]}>{user.full_name} of {props.address}, wants to move ahead with the {props.projectName} project you quoted them.</Text>,
        <Text style={[CS.smallText, CS.lightBlueText, styles.paragraph]}>Your customer wants to use Renovation Trust to protect the money for both you and them.</Text>,
        <Text style={[CS.smallText, CS.lightBlueText, styles.paragraph]}>As their contractor, they would like you to set up the project in Renovation Trust and then invite them to join and accept the project terms. Once they have joined and accepted the project, they will deposit the full cost of the project with Renovation Trust. Once the funds have cleared, we will inform you so you can begin the work and request payments at your agreed to milestones and/or upon completion.</Text>,
        <Text style={[CS.smallText, CS.lightBlueText]}>Your Customer's Information</Text>,
        <Text style={[CS.smallText, CS.lightBlueText]}>{user.full_name}</Text>,
        <Text style={[CS.smallText, CS.lightBlueText]}>{user.phone_number_mobile || user.phone_number_home}</Text>,
        <Text style={[CS.smallText, CS.lightBlueText, styles.paragraph]}>{user.email_address}</Text>,
        <Text style={[CS.smallText, CS.lightBlueText, styles.paragraph]}>Reach out to your customer if you need clarification or to discuss any matters.</Text>,
        <Text style={[CS.smallText, CS.lightBlueText, styles.paragraph]}>If you don’t have an account already, you will have an opportunity to create one before viewing the project details. Otherwise you’ll be prompted to login.</Text>,
      ],
    },
    contractor: {
      Project: [
        <Text style={[CS.smallText, CS.lightBlueText, styles.paragraph]}>Your contractor {props.toName}, from {user.company_name}, has created your {props.projectName} project in Renovation Trust providing protection for both of you.</Text>,
        <Text style={[CS.smallText, CS.lightBlueText, styles.paragraph]}>You need to review the details and accept the project before things can proceed.</Text>,
        <Text style={[CS.smallText, CS.lightBlueText, styles.paragraph]}>If you don’t have an account already, you will have an opportunity to create one before viewing the project details. Otherwise you’ll be prompted to login.</Text>,
        <Text style={[CS.smallText, CS.lightBlueText]}>Your Contractor’s Information:</Text>,
        <Text style={[CS.smallText, CS.lightBlueText]}>{user.company_name}</Text>,
        <Text style={[CS.smallText, CS.lightBlueText]}>{user.full_name}</Text>,
        <Text style={[CS.smallText, CS.lightBlueText]}>{user.company_phone_number}</Text>,
        <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 10 }]}>{user.company_email}</Text>,
        // <Text style={[CS.smallText, CS.lightBlueText, styles.paragraph, { marginTop: 10 }]}>{user.email_address}</Text>,
      ],
      // Create: [
      //   <Text style={[CS.smallText, CS.lightBlueText, styles.paragraph]}></Text>,
      // ],
    },
  }
  // `${user.full_name}, of ${props.address}, wants to move forward with their ${props.projectName} project using Renovation Trust to protect themselves and you. This is an invitation to join and accept the project. Once you accept the project they’ll deposit the entire cost of the project with Renovation Trust and it will be released to you as the project is completed. You can rest assured you will get paid as your client will have already deposited the funds for the entire project - it’s just waiting for you to finish. Click to sign up/login and view the project details!`;

  const Link = (props) => {
    return (
      <TouchableOpacity style={styles.link} onPress={() => goToLink(props.url)} activeOpacity={0.6}>
        <Text style={[CS.smallText, styles.linkText]}>{props.url}</Text>
      </TouchableOpacity>
    );
  }
  const goToLink = async (url) => {
    await WebBrowser.openBrowserAsync(url);
  };

  const call = () => {
    console.log('call');
    Linking.openURL('tel:1-800-673-9716');
  }
  const chat = () => {
    if (Platform.OS === 'web' && window.fcWidget) {
      window.fcWidget.open();
      window.fcWidget.show();
    } else {
      const subDomain = __DEV__ ? 'dev' : 'www';
      WebBrowser.openBrowserAsync(`https://${subDomain}.renovationtrust.com/contact_us?chat=${user.account_id}&first_name=${user.first_name}&last_name=${user.last_name}&email_address=${user.email_address}`);
    }
  }
  const contact = async () => {
    console.log('contact');
    await WebBrowser.openBrowserAsync('https://www.renovationtrust.com/contact_us');
  }

  const contactButtonsStyle = () => {
    if(windowWidth < 450){
      return {
        flexDirection: 'column',
      }
    }
    return {};
  }
  const contactButtonStyle = () => {
    if (windowWidth < 450) {
      return {
        width: '100%',
        marginBottom: 10,
      }
    }
    return {};
  }

  if (Platform.OS === 'web' && !props.show) { return null; }
  return (
    <Portal>
      <Modal animationType='none' transparent={true} visible={props.show} style={Platform.OS === 'web' && CS.webModal}>
        <BackgroundGradient />
        <ScrollView style={styles.scrollview} contentContainerStyle={[styles.innerContainer, { paddingTop: insets.top, paddingBottom: insets.bottom }]}>
          <View style={styles.titleContainer}>
            <TouchableOpacity onPress={props.cancel} style={styles.backArrow}>
              <FontAwesome5 name="arrow-left" size={24} color="white" />
            </TouchableOpacity>
            <Text style={[CS.mediumTitle, CS.lightText, CS.centerText, { marginVertical: 0 }]}>Invitation Preview</Text>
          </View>
          <Text style={[CS.smallText, CS.lightText, CS.italicText, styles.topBlurb]}>{topBlurb}</Text>
          <View style={styles.toggles}>
            {props.email && props.sms &&
              <ToggleButtons setValue={setPreviewType} value={previewType} button1Text={"Email"} button2Text={"Text / SMS"} />
            }
            {props.email && !props.sms &&
              <Button text='Email' onPress={() => {}} />
            }
            {!props.email && props.sms &&
              <Button text='Text / SMS' onPress={() => {}} />
            }
          </View>
          {previewType &&
            <View style={styles.previewContainer}>
              <Text style={[CS.smallText, CS.lightText, styles.paragraph]}>To: {props.emailAddress}</Text>
            {emailContent[props.role][['Project', 'Customer', 'Contractor'].includes(props.inviteType) ? 'Project' : props.inviteType].map((c, i) => {
                // return (<Text style={[CS.smallText, CS.lightBlueText, styles.paragraph]} key={i}>{c}</Text>)
                return (<View key={i}>{c}</View>)
              })}
              {personalMessage()}
              {contactBlurb()}
            </View>
          }
          {!previewType &&
            <View style={styles.previewContainer}>
              <Text style={[CS.smallText, CS.lightText, styles.paragraph]}>To: {props.phoneNumber}</Text>
            {smsContent[props.role][['Project', 'Customer', 'Contractor'].includes(props.inviteType) ? 'Project' : props.inviteType].map((c, i) => {
                // return (<Text style={[CS.smallText, CS.lightBlueText, styles.paragraph]} key={i}>{c}</Text>)
                return (<View key={i}>{c}</View>)
              })}
            {personalMessage()}
            {contactBlurb()}
            </View>
          }
          <View style={styles.contactContainer}>
            <View style={[styles.contactButtons, contactButtonsStyle()]}>
              <TouchableOpacity activeOpacity={0.6} onPress={call} style={[styles.contactButton, contactButtonStyle()]}>
                <AntDesign name="phone" size={60} color={Colors.lightBlue} style={styles.contactIcon} />
                <Text style={[CS.miniText, CS.lightBlueText, CS.italicText]}>(800)673-9716</Text>
              </TouchableOpacity>
              <TouchableOpacity activeOpacity={0.6} onPress={chat} style={[styles.contactButton, contactButtonStyle()]}>
                <AntDesign name="wechat" size={60} color={Colors.lightBlue} style={styles.contactIcon} />
                <Text style={[CS.miniText, CS.lightBlueText, CS.italicText]}>Chat With Us</Text>
              </TouchableOpacity>
              <TouchableOpacity activeOpacity={0.6} onPress={contact} style={[styles.contactButton, contactButtonStyle()]}>
                <AntDesign name="form" size={60} color={Colors.lightBlue} style={styles.contactIcon} />
                <Text style={[CS.miniText, CS.lightBlueText, CS.italicText]}>Contact Us</Text>
              </TouchableOpacity>
            </View>
          </View>

          <View style={{ marginBottom: 10 }}>
            <Button text='Send Invitation' onPress={() => props.send} />
          </View>
        </ScrollView>
      </Modal>
    </Portal>
  )
}

const styles = StyleSheet.create({
  scrollview: {
    // marginVertical: 10,
    // backgroundColor: Colors.blue,
    // backgroundColor: 'orange',
  },
  innerContainer: {
    width: '100%',
    // backgroundColor: 'pink',
    maxWidth: Platform.OS === 'web' ? 768 : '100%',
    justifyContent: Platform.OS === 'web' ? 'center' : 'flex-start',
    alignSelf: Platform.OS === 'web' ? 'center' : 'stretch',
    // flex: 1,
    padding: 10,
  },
  titleContainer: {
    marginVertical: 10,
    paddingHorizontal: 30,
  },
  backArrow: {
    position:'absolute',
    top:0,
    left:0,
  },
  toggles: {
    marginVertical: 20,
  },
  paragraph: {
    marginBottom: 20,
    // flex: 1,
    // textAlign: 'justify',
  },
  previewContainer: {
    borderRadius: 10,
    borderColor: Colors.lightBlue,
    backgroundColor: Colors.textInputBackground,
    borderWidth: 1,
    padding: 20,
    paddingBottom: 0,
    marginBottom: 20,
  },
  topBlurb: {
    marginTop: 20,
  },
  contactButtons: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 20,
  },
  contactButton: {
    alignItems: 'center',
    justifyContent: 'center',
    // width: 60,
    borderColor: Colors.lightBlue,
    borderWidth: 1,
    borderRadius: 10,
    padding: 10,
    backgroundColor: Colors.textInputBackground,
    marginHorizontal: 10,
    width: 125,
  },
  chatIcon: {
    marginBottom: 20,
  },
  linkText: {
    color: Colors.yellow,
  },
});